import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { ENABLE_BUSINESS_PROFILE_HEADER } from '#client/constants/experimentsFlags';

import ProfileHeader from './ProfileHeader';

function ProfileHeaderGateway() {
  const enableBusinessProfileHeader = useExperimentFlag(ENABLE_BUSINESS_PROFILE_HEADER, false);

  if (!enableBusinessProfileHeader) {
    return null;
  }

  return <ProfileHeader />;
}

export default ProfileHeaderGateway;
